"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAndDrawOnCanvas = void 0;
var resetAndDrawOnCanvas = function (ctx, canvasSize, drawElements) {
    window.requestAnimationFrame(function () {
        // draw bg color
        ctx.clearRect(0, 0, canvasSize.width, canvasSize.height);
        drawElements();
    });
};
exports.resetAndDrawOnCanvas = resetAndDrawOnCanvas;
